import React from 'react'

import PathBreakdown, { PathBreakdownProvider } from 'components/PathBreakdown'
import { HorizontalScrollTable } from 'components/ArticleComponents'
import { YesTableIcon } from './TableIcons'
import { ConditionalMDXSection } from './ConditionalMDXSection'

const descriptions = {
	customerId: 'A unique identifier for your customer',
	currencyCode: (
		<>
			3-letter currency code in <a href='https://en.wikipedia.org/wiki/ISO_4217#Active_codes'>ISO 4217</a> format, e.g.{' '}
			<code>USD</code> for US dollars
		</>
	),
	'order.lineItems': 'Details of the line items of the order',
	'order.countryCode': 'The country in which the order is created',
}

const defaultClientSessionParams = [
	{ name: 'currencyCode', required: true },
	{ name: 'order.lineItems', required: true },
]

export const ClientSessionParams = ({ defaultParams, additionalParams }) => {
	const required = defaultParams ?? defaultClientSessionParams
	const parameters = [...required, ...(additionalParams || [])]

	// in case of duplicates, keep only the last occurrence of each parameter
	// (the one from additionalParams) to allow for manual overrides
	const uniqueParameters = [
        ...new Map(
            parameters.map(item => [item.name, item])
        ).values()
	];

	return (
		<HorizontalScrollTable>
			<thead>
				<tr>
					<th>Parameter Name</th>
					<th>Required</th>
					<th>Description</th>
				</tr>
			</thead>
			<tbody>
				<PathBreakdownProvider method='POST' path='/client-session' source='request.body'>
					{uniqueParameters.map(({ name, required, description }) => (
						<tr key={name}>
							<td>
								<PathBreakdown>{name}</PathBreakdown>
							</td>
							<td>{required && YesTableIcon}</td>
							<td>
								{description?.body ? <ConditionalMDXSection content={description} topLevel={1} /> : descriptions[name]}
							</td>
						</tr>
					))}
				</PathBreakdownProvider>
			</tbody>
		</HorizontalScrollTable>
	)
}

const defaultVaultParams = [{ name: 'customerId', required: true }]

export const VaultClientSessionParams = props => <ClientSessionParams {...props} defaultParams={defaultVaultParams} />
